$(function() {
    const $progress = $('.js-import-progress')
    if (!$progress.length) {
        return
    }

    const uuid = $progress.data('uuid')

    let timerId = null

    function updateProgress() {
        $.ajax({
            method: 'GET',
            url: '/ftasks/importResult/',
            data: {
                "uuid": uuid,
            },
            success: function (response) {
                let value = response.data.progress;
                $progress.css('width', value + '%').text(value + '%')

                if (value == "100")
                {
                    if (timerId !== null) {
                        clearTimeout(timerId)
                    }

                    window.location.reload()
                }
            }
        })
    }

    updateProgress()

    timerId = setInterval(function() {
        updateProgress()
    }, 5000)
})
